module.exports = __webpack_public_path__ + "static/Apercu-Italic-534a0cf80857dea74e348b04fbc14cb3.svg";